import { EstacionPopup } from './estacion-popup';
import { PopupInfoItem } from './entity-popup.interface';

/**
 * Popup para estaciones meteorológicas.
 * Muestra datos de humedad ambiente, temperatura, lluvia, viento y radiación solar.
 */
export class MeteorologicaPopup extends EstacionPopup {
  getBadgeText(): string {
    return `Estación Meteorológica de ${this.entity.provider} (Id ${this.entity.provider_id})`;
  }

  getInfoItems(): PopupInfoItem[] {
    const items: PopupInfoItem[] = [
      this.createSensorItem(
        this.entity.ambiental_humidity_last,
        'Humedad ambiente',
        'humidity_low',
        '%'
      ),
      this.createSensorItem(
        this.entity.ambiental_temperature_last,
        'Temperatura ambiente',
        'device_thermostat',
        '°C'
      ),
    ];

    // Lluvia acumulada tiene un formato especial con rango de fechas
    const rain = this.entity.rain_precipitaciones;
    if (rain?.precipitation_start_week && rain?.precipitation_end_week) {
      const startDate = this.datePipe.transform(
        rain.precipitation_start_week,
        'dd/MM/yyyy'
      );
      const endDate = this.datePipe.transform(
        rain.precipitation_end_week,
        'dd/MM/yyyy'
      );
      items.push({
        icon: 'rainy',
        label: 'Lluvia acumulada',
        value: rain.value,
        unit: 'L/m²',
        date: `${startDate} - ${endDate}`,
      });
    } else {
      items.push({
        icon: 'rainy',
        label: 'Lluvia acumulada',
        value: null,
      });
    }

    items.push(
      this.createSensorItem(
        this.entity.ambiental_wind_last,
        'Velocidad del viento',
        'air',
        'km/h'
      ),
      this.createSensorItem(
        this.entity.solar_radiation_last,
        'Radiación solar',
        'clear_day',
        'W/m²'
      )
    );

    return items;
  }
}
